import React, { useState, useRef } from "react";
import Header from "../../components/header/Header";
import photo from "../../files/fond.jpg";
import emailjs from "@emailjs/browser";

const Info = ({ title, text }) => (
	<div style={{ marginBottom: "15px" }}>
		<span
			style={{
				display: "block",
				color: "#ffd700",
				fontWeight: "600",
				fontSize: "15px",
				marginBottom: "3px",
			}}
		>
			{title}
		</span>

		<span
			style={{
				display: "block",
				color: "#d8dde4",
				fontSize: "15px",
				wordBreak: "break-word",
			}}
		>
			{text}
		</span>
	</div>
);

const Contact = () => {
	const [email, setEmail] = useState("");
	const [nom, setNom] = useState("");
	const [tel, setTel] = useState("");
	const [message, setMessage] = useState("");
	const [notif, setNotif] = useState(null);

	const formRef = useRef();

	const mobile = window.innerWidth <= 768;
	const smallMobile = window.innerWidth <= 400;

	const sendMail = (ev) => {
		ev.preventDefault();

		emailjs
			.sendForm(
				process.env.REACT_APP_SERVICE_ID,
				process.env.REACT_APP_TEMPLATE_ID,
				formRef.current,
				process.env.REACT_APP_PUBLIC_KEY
			)
			.then(
				() => {
					setNotif({
						type: "success",
						text: "Mail envoyé avec succès !",
					});

					setTimeout(() => setNotif(null), 4000);

					setEmail("");
					setNom("");
					setTel("");
					setMessage("");
				},
				(error) => {
					console.log("FAILED...", error);

					setNotif({
						type: "error",
						text:
							"Échec de l'envoi. Vous pouvez me contacter au : maheriarimanana@gmail.com",
					});

					setTimeout(() => setNotif(null), 4000);
				}
			);
	};

	const inputStyle = {
		width: "100%",
		padding: "12px 15px",
		border: "1px solid transparent",
		borderRadius: "8px",
		background: "rgba(255,255,255,0.9)",
		color: "#333",
		fontSize: "15px",
		fontFamily: "inherit",
		outline: "none",
		boxSizing: "border-box",
	};

	return (
		<div
			style={{
				minHeight: "100vh",
				width: "100%",
				margin: 0,
				padding: 0,
				fontFamily: "Poppins, sans-serif",
				backgroundImage: `linear-gradient(rgba(15,32,39,0.8), rgba(44,83,100,0.8)), url(${photo})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundAttachment: mobile ? "scroll" : "fixed",
			}}
		>
			<Header />

			<div
				style={{
					width: "100%",
					maxWidth: "1200px",
					margin: "auto",
					padding: mobile ? "100px 15px 40px" : "120px 20px 60px",
					boxSizing: "border-box",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: mobile ? "column" : "row",
						alignItems: "center",
						justifyContent: "center",
						gap: mobile ? "30px" : "50px",
						width: "100%",
					}}
				>
					{/* INFORMATIONS */}
					<div
						style={{
							width: "100%",
							flex: 1,
							color: "#fff",
							minWidth: 0,
						}}
					>
						<h1
							style={{
								fontSize: smallMobile ? "30px" : mobile ? "36px" : "48px",
								margin: "0 0 15px",
								fontWeight: "700",
							}}
						>
							Travaillons ensemble
						</h1>

						<h2
							style={{
								color: "#ffd700",
								fontSize: smallMobile ? "17px" : mobile ? "19px" : "22px",
								fontWeight: "500",
								margin: "0 0 25px",
							}}
						>
							Construisons ensemble des solutions web modernes
						</h2>

						<p
							style={{
								color: "#d8dde4",
								fontSize: mobile ? "16px" : "18px",
								lineHeight: "1.8",
								margin: 0,
							}}
						>
							Vous avez un projet, une opportunité professionnelle
							ou souhaitez échanger autour du développement web ?
							<br />
							<br />
							Je suis actuellement à la recherche d'une opportunité de{" "}
							<strong style={{ color: "#fff" }}>
								Développeur Fullstack ou Frontend en télétravail
							</strong>.
						</p>

						<div
							style={{
								marginTop: "35px",
								padding: smallMobile ? "18px" : "25px",
								background: "rgba(255,255,255,0.08)",
								border: "1px solid rgba(255,255,255,0.15)",
								borderRadius: "15px",
								backdropFilter: "blur(8px)",
							}}
						>
							<Info
								title="Localisation"
								text="Madagascar • Disponible en télétravail international"
							/>
						</div>
					</div>

					{/* FORMULAIRE */}
					<form
						ref={formRef}
						onSubmit={sendMail}
						style={{
							width: "100%",
							flex: 1,
							minWidth: 0,
							padding: smallMobile ? "18px 12px" : mobile ? "20px 15px" : "30px",
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: "15px",
							background: "rgba(255,255,255,0.08)",
							border: "1px solid rgba(255,255,255,0.2)",
							borderRadius: "20px",
							backdropFilter: "blur(8px)",
							boxShadow: "0 10px 40px rgba(0,0,0,0.35)",
							boxSizing: "border-box",
						}}
					>
						<h2
							style={{
								color: "#fff",
								fontSize: mobile ? "26px" : "32px",
								textAlign: "center",
								margin: 0,
							}}
						>
							Envoyer un message
						</h2>

						<p
							style={{
								color: "#ddd",
								fontSize: "15px",
								textAlign: "center",
								margin: "0 0 15px",
							}}
						>
							Je vous répondrai dans les meilleurs délais.
						</p>

						<input
							type="text"
							name="from_name"
							required
							placeholder="Nom Complet"
							value={nom}
							onChange={(e) => setNom(e.target.value)}
							style={inputStyle}
						/>

						<input
							type="email"
							name="from_email"
							required
							placeholder="Email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							style={inputStyle}
						/>

						<input
							type="text"
							name="phone"
							required
							placeholder="Téléphone"
							value={tel}
							onChange={(e) => setTel(e.target.value)}
							style={inputStyle}
						/>

						<textarea
							name="message"
							required
							placeholder="Message"
							value={message}
							onChange={(e) => setMessage(e.target.value)}
							style={{
								...inputStyle,
								height: "120px",
								resize: "vertical",
							}}
						/>

						{notif && (
							<div
								style={{
									width: "100%",
									padding: "10px 15px",
									borderRadius: "8px",
									textAlign: "center",
									fontWeight: "600",
									background:
										notif.type === "success"
											? "rgba(0,255,0,0.25)"
											: "rgba(255,0,0,0.25)",
									color:
										notif.type === "success"
											? "#00ff01"
											: "#ff4444",
								}}
							>
								{notif.text}
							</div>
						)}

						<button
							type="submit"
							style={{
								width: "100%",
								height: "45px",
								border: "none",
								borderRadius: "25px",
								background: "#1f3a43",
								color: "#fff",
								fontSize: "16px",
								fontWeight: "600",
								cursor: "pointer",
							}}
						>
							Envoyer
						</button>
					</form>
				</div>
			</div>
		</div>
	);
};

export default Contact;